// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var IdMaker$SmartcutsMacros = require("../../bs-utils/src/IdMaker.bs.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var LoginSmartcut$SmartcutsMacros = require("./LoginSmartcut.bs.js");
var OAuthProvider$SmartcutsMacros = require("./OAuthProvider.bs.js");
var UserCredential__OAuthCredential$SmartcutsMacros = require("./UserCredential__OAuthCredential.bs.js");
var UserCredential__PasswordCredential$SmartcutsMacros = require("./UserCredential__PasswordCredential.bs.js");

function t_encode(encoder_oauthProviderCredential, v) {
  if (v.TAG === /* PasswordCredential */0) {
    return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdOrPassword.t_encode(v._0)
          ];
  } else {
    return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(encoder_oauthProviderCredential, v._0)
          ];
  }
}

function t_decode(decoder_oauthProviderCredential, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(decoder_oauthProviderCredential, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OAuthCredential */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdOrPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCredential */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(stringifyOAuthProviderCredential, credential) {
  if (credential.TAG !== /* PasswordCredential */0) {
    return "OAuthCredential(" + (UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.stringify(stringifyOAuthProviderCredential, credential._0) + ")");
  }
  var match = credential._0;
  return "PasswordCredential(hostname=" + (match.hostname + (", username=" + (match.username + ")")));
}

function hostnameGet(v) {
  return v._0.hostname;
}

var GenericWithoutIdOrSecureData = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  hostnameGet: hostnameGet
};

function t_encode$1(encoder_oauthProviderCredential, v) {
  if (v.TAG === /* PasswordCredential */0) {
    return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_encode(v._0)
          ];
  } else {
    return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(encoder_oauthProviderCredential, v._0)
          ];
  }
}

function t_decode$1(decoder_oauthProviderCredential, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(decoder_oauthProviderCredential, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OAuthCredential */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCredential */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(stringifyOAuthProviderCredential, credential) {
  if (credential.TAG !== /* PasswordCredential */0) {
    return "OAuthCredential(" + (UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.stringify(stringifyOAuthProviderCredential, credential._0) + ")");
  }
  var match = credential._0;
  return "PasswordCredential(hostname=" + (match.hostname + (", username=" + (match.username + ")")));
}

function hostnameGet$1(v) {
  return v._0.hostname;
}

var GenericWithoutIdWithPassword = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  hostnameGet: hostnameGet$1
};

function t_encode$2(v) {
  return t_encode(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v);
}

function t_decode$2(v) {
  return t_decode(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v);
}

function stringify$2(param) {
  return stringify((function (param) {
                return "";
              }), param);
}

var WithoutIdOrSecureDataAndWithNestedProviderCredentialRef = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2
};

function t_encode$3(v) {
  if (v.TAG === /* PasswordCredential */0) {
    return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_encode(v._0)
          ];
  } else {
    return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v._0)
          ];
  }
}

function t_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OAuthCredential */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCredential */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$3(v) {
  if (v.TAG === /* PasswordCredential */0) {
    return "PasswordCredential(" + (UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.stringify(v._0) + ")");
  }
  var func = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.stringify;
  return "OAuthCredential(" + (Curry._2(func, (function (prim) {
                  return prim;
                }), v._0) + ")");
}

var WithoutIdWithPasswordAndWithNestedProviderCredentialRef = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$3
};

function t_encode$4(v) {
  if (v.TAG === /* PasswordCredential */0) {
    return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_encode(v._0)
          ];
  } else {
    return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_encode(UserCredential__PasswordCredential$SmartcutsMacros.t_encode, v._0)
          ];
  }
}

function t_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = UserCredential__OAuthCredential$SmartcutsMacros.WithoutId.t_decode(UserCredential__PasswordCredential$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OAuthCredential */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithoutIdWithPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCredential */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function hostnameGet$2(v) {
  return v._0.hostname;
}

function usernameGet(v) {
  if (v.TAG === /* PasswordCredential */0) {
    return v._0.username;
  } else {
    return v._0.oauthProviderCredential.username;
  }
}

var WithoutIdWithPasswordAndHydratedOAuthProviderCredential = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  hostnameGet: hostnameGet$2,
  usernameGet: usernameGet
};

function t_encode$5(encoder_oauthProviderCredential, v) {
  if (v.TAG === /* PasswordCredential */0) {
    return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.t_encode(v._0)
          ];
  } else {
    return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.t_encode(encoder_oauthProviderCredential, v._0)
          ];
  }
}

function t_decode$5(decoder_oauthProviderCredential, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = UserCredential__OAuthCredential$SmartcutsMacros.t_decode(decoder_oauthProviderCredential, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OAuthCredential */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCredential */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var Generic = {
  t_encode: t_encode$5,
  t_decode: t_decode$5
};

var include = IdMaker$SmartcutsMacros.Make({
      name: "DbId"
    });

var id_encode = include.id_encode;

var id_decode = include.id_decode;

function fromPasswordCredentialId(passwordId) {
  return passwordId;
}

function toPasswordCredentialId(dbId) {
  return dbId;
}

function toOAuthCredentialId(dbId) {
  return dbId;
}

var DbId_doesEqualStringId = include.doesEqualStringId;

var DbId_cmp = include.cmp;

var DbId = {
  id_encode: id_encode,
  id_decode: id_decode,
  doesEqualStringId: DbId_doesEqualStringId,
  cmp: DbId_cmp,
  fromPasswordCredentialId: fromPasswordCredentialId,
  toPasswordCredentialId: toPasswordCredentialId,
  toOAuthCredentialId: toOAuthCredentialId
};

function t_encode$6(v) {
  return t_encode$5(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v);
}

function t_decode$6(v) {
  return t_decode$5(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v);
}

function stringify$4(credential) {
  if (credential.TAG !== /* PasswordCredential */0) {
    return "OAuthCredential(oauthProvider=" + (OAuthProvider$SmartcutsMacros.stringify(credential._0.oauthProvider) + ")");
  }
  var match = credential._0;
  return "PasswordCredential(hostname=" + (match.hostname + (", username=" + (match.username + ")")));
}

function dbIdGet(credential) {
  return credential._0.id;
}

function hostnameGet$3(credential) {
  return credential._0.hostname;
}

function isPasswordCredential(credential) {
  if (credential.TAG === /* PasswordCredential */0) {
    return true;
  } else {
    return false;
  }
}

function doesMatchUrl(url, credential) {
  var match = URLUtils$SmartcutsMacros.$$URL.fromString(url);
  if (match !== undefined) {
    return credential._0.hostname === match.origin;
  } else {
    return false;
  }
}

var WithExistingCredentialOrCreatePasswordCredential = {};

var WithoutIdOrSecureDataWithNestedNewOrExistingPasswordCredentialForOAuth = {};

var WithoutIdWithPasswordWithNestedNewOrExistingPasswordCredentialForOAuth = {};

function t_encode$7(v) {
  return Js_dict.fromArray([
              [
                "id",
                Curry._1(id_encode, v.id)
              ],
              [
                "hostname",
                Decco.stringToJson(v.hostname)
              ],
              [
                "credentialSchemaVersion",
                Decco.stringToJson(v.credentialSchemaVersion)
              ],
              [
                "credential",
                t_encode(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v.credential)
              ]
            ]);
}

function t_decode$7(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Curry._1(id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
    if (hostname.TAG === /* Ok */0) {
      var credentialSchemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialSchemaVersion"), null));
      if (credentialSchemaVersion.TAG === /* Ok */0) {
        var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "credential"), null);
        var credential = t_decode(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v$1);
        if (credential.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    hostname: hostname._0,
                    credentialSchemaVersion: credentialSchemaVersion._0,
                    credential: credential._0
                  }
                };
        }
        var e = credential._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".credential" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = credentialSchemaVersion._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".credentialSchemaVersion" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = hostname._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".hostname" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function usernameGet$1(param) {
  return param.credential._0.username;
}

var DbRecord = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  usernameGet: usernameGet$1
};

function t_encode$8(v) {
  if (v.TAG === /* PasswordCredential */0) {
    return [
            "PasswordCredential",
            UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_encode(v._0)
          ];
  } else {
    return [
            "OAuthCredential",
            UserCredential__OAuthCredential$SmartcutsMacros.t_encode(UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_encode, v._0)
          ];
  }
}

function t_decode$8(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = UserCredential__OAuthCredential$SmartcutsMacros.t_decode(UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OAuthCredential */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordCredential" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = UserCredential__PasswordCredential$SmartcutsMacros.WithIdAndNeedsReEntryStatusWithoutPassword.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCredential */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function makeFromDbIdAndFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef(id, userCredential, credentialsThatNeedPasswordReEntry, credentialsFromDb) {
  if (userCredential.TAG === /* PasswordCredential */0) {
    var match = userCredential._0;
    return {
            TAG: /* PasswordCredential */0,
            _0: {
              id: id,
              hostname: match.hostname,
              username: match.username,
              reEntryStatus: Belt_Array.some(credentialsThatNeedPasswordReEntry, (function (currId) {
                      return Caml_obj.caml_equal(currId, id);
                    })) ? /* DoesNeedToBeReentered */1 : /* DoesNotNeedToBeReentered */2
            }
          };
  }
  var match$1 = userCredential._0;
  var providerPasswordCredentialId = match$1.oauthProviderCredential;
  var arg = Belt_Array.getBy(credentialsFromDb, (function (x) {
          return Caml_obj.caml_equal(x.id, providerPasswordCredentialId);
        }));
  var matchingProviderPassCredential = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected password credential with id" + providerPasswordCredentialId);
  return {
          TAG: /* OAuthCredential */1,
          _0: {
            id: id,
            hostname: match$1.hostname,
            username: match$1.username,
            oauthProvider: match$1.oauthProvider,
            oauthProviderCredential: {
              id: providerPasswordCredentialId,
              hostname: matchingProviderPassCredential.hostname,
              username: usernameGet$1(matchingProviderPassCredential),
              reEntryStatus: Belt_Array.some(credentialsThatNeedPasswordReEntry, (function (idOfCred) {
                      return Caml_obj.caml_equal(idOfCred, providerPasswordCredentialId);
                    })) ? /* DoesNeedToBeReentered */1 : /* DoesNotNeedToBeReentered */2
            }
          }
        };
}

function dbIdGet$1(credential) {
  return credential._0.id;
}

function hostnameGet$4(credential) {
  return credential._0.hostname;
}

function isPasswordCredential$1(credential) {
  if (credential.TAG === /* PasswordCredential */0) {
    return true;
  } else {
    return false;
  }
}

function doesMatchHostname(hostnameToMatch, credential) {
  return credential._0.hostname === hostnameToMatch;
}

function needsReEntryPassword(credential) {
  if (credential.TAG === /* PasswordCredential */0) {
    return credential._0.reEntryStatus === 1;
  } else {
    return credential._0.oauthProviderCredential.reEntryStatus === 1;
  }
}

var WithReEntryStatusAndOAuthProviderCredential = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  makeFromDbIdAndFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef: makeFromDbIdAndFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef,
  dbIdGet: dbIdGet$1,
  hostnameGet: hostnameGet$4,
  isPasswordCredential: isPasswordCredential$1,
  doesMatchHostname: doesMatchHostname,
  needsReEntryPassword: needsReEntryPassword
};

function t__encode(v) {
  return t_encode$5(UserCredential__PasswordCredential$SmartcutsMacros.t_encode, v);
}

function t__decode(v) {
  return t_decode$5(UserCredential__PasswordCredential$SmartcutsMacros.t_decode, v);
}

function fromUnresolved(userCredentials, unresolvedCredential) {
  if (unresolvedCredential.TAG === /* PasswordCredential */0) {
    return {
            TAG: /* PasswordCredential */0,
            _0: unresolvedCredential._0
          };
  }
  var match = unresolvedCredential._0;
  var passwordCredentialId = match.oauthProviderCredential;
  var oauthProviderCredential = ArrayUtils$SmartcutsMacros.shortcut((function (credential) {
          if (credential.TAG !== /* PasswordCredential */0) {
            return ;
          }
          var oauthProviderCredential = credential._0;
          if (Caml_obj.caml_equal(oauthProviderCredential.id, passwordCredentialId)) {
            return oauthProviderCredential;
          }
          
        }), userCredentials);
  if (oauthProviderCredential !== undefined) {
    return {
            TAG: /* OAuthCredential */1,
            _0: {
              id: match.id,
              hostname: match.hostname,
              username: oauthProviderCredential.username,
              oauthProvider: match.oauthProvider,
              oauthProviderCredential: {
                id: oauthProviderCredential.id,
                hostname: oauthProviderCredential.hostname,
                username: oauthProviderCredential.username
              }
            }
          };
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Could not resolve oauthProviderCredential with id = " + passwordCredentialId + " ");
  }
}

function getIdOfUnderlyingPasswordCredential(credential) {
  if (credential.TAG === /* PasswordCredential */0) {
    return credential._0.id;
  } else {
    return credential._0.oauthProviderCredential.id;
  }
}

var WithOAuthProviderCredential = {
  t__encode: t__encode,
  t__decode: t__decode,
  fromUnresolved: fromUnresolved,
  getIdOfUnderlyingPasswordCredential: getIdOfUnderlyingPasswordCredential
};

function t_encode$9(v) {
  if (v.TAG === /* PasswordCredentialRef */0) {
    return [
            "PasswordCredentialRef",
            Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v._0)
          ];
  } else {
    return [
            "OAuthCredentialRef",
            Curry._1(UserCredential__OAuthCredential$SmartcutsMacros.id_encode, v._0)
          ];
  }
}

function t_decode$9(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthCredentialRef" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(UserCredential__OAuthCredential$SmartcutsMacros.id_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OAuthCredentialRef */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordCredentialRef" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCredentialRef */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function make(credential) {
  if (credential.TAG === /* PasswordCredential */0) {
    return {
            TAG: /* PasswordCredentialRef */0,
            _0: credential._0.id
          };
  } else {
    return {
            TAG: /* OAuthCredentialRef */1,
            _0: credential._0.id
          };
  }
}

function stringify$5(credentialRef) {
  if (credentialRef.TAG === /* PasswordCredentialRef */0) {
    return "PasswordCredentialRef(" + credentialRef._0 + ")";
  } else {
    return "OAuthCredentialRef(" + credentialRef._0 + ")";
  }
}

function fromUserCredential(userCredential) {
  if (userCredential.TAG === /* PasswordCredential */0) {
    return {
            TAG: /* PasswordCredentialRef */0,
            _0: userCredential._0.id
          };
  } else {
    return {
            TAG: /* OAuthCredentialRef */1,
            _0: userCredential._0.id
          };
  }
}

var CredentialRef = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  make: make,
  stringify: stringify$5,
  fromUserCredential: fromUserCredential
};

function doesMatchCredentialRef(credentialRef, credential) {
  if (credential.TAG === /* PasswordCredential */0) {
    if (credentialRef.TAG === /* PasswordCredentialRef */0) {
      return Caml_obj.caml_equal(credential._0.id, credentialRef._0);
    } else {
      return false;
    }
  } else if (credentialRef.TAG === /* PasswordCredentialRef */0) {
    return false;
  } else {
    return Caml_obj.caml_equal(credential._0.id, credentialRef._0);
  }
}

function toWithoutIdOrSecureDataAndWithNestedProviderCredentialRef(userCredential) {
  if (userCredential.TAG === /* PasswordCredential */0) {
    var match = userCredential._0;
    return {
            TAG: /* PasswordCredential */0,
            _0: {
              hostname: match.hostname,
              username: match.username
            }
          };
  }
  var match$1 = userCredential._0;
  return {
          TAG: /* OAuthCredential */1,
          _0: {
            hostname: match$1.hostname,
            username: match$1.username,
            oauthProvider: match$1.oauthProvider,
            oauthProviderCredential: match$1.oauthProviderCredential
          }
        };
}

function makeFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef(id, userCredential) {
  if (userCredential.TAG === /* PasswordCredential */0) {
    var match = userCredential._0;
    return {
            TAG: /* PasswordCredential */0,
            _0: {
              id: id,
              hostname: match.hostname,
              username: match.username
            }
          };
  }
  var match$1 = userCredential._0;
  return {
          TAG: /* OAuthCredential */1,
          _0: {
            id: id,
            hostname: match$1.hostname,
            username: match$1.username,
            oauthProvider: match$1.oauthProvider,
            oauthProviderCredential: match$1.oauthProviderCredential
          }
        };
}

function buildDefaultCredentialDbIdsByHostname(loginSmartcuts, userCredentials) {
  return Belt_Array.reduce(Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.getHostnames, loginSmartcuts), undefined, (function (credentialDbIdsByHostname, hostname) {
                var maybeDbId = Belt_Array.get(Belt_Array.keepMap(userCredentials, (function (credential) {
                            if (doesMatchHostname(hostname, credential) && !needsReEntryPassword(credential)) {
                              return Caml_option.some(dbIdGet$1(credential));
                            }
                            
                          })), 0);
                if (maybeDbId !== undefined) {
                  return Belt_MapString.set(credentialDbIdsByHostname, hostname, Caml_option.valFromOption(maybeDbId));
                } else {
                  return credentialDbIdsByHostname;
                }
              }));
}

function areCredentialDbIdsByHostnameIdentical(credentialDbIdsByHostname_A, credentialDbIdsByHostname_B) {
  if (Belt_MapString.size(credentialDbIdsByHostname_A) === Belt_MapString.size(credentialDbIdsByHostname_B)) {
    return Belt_MapString.every(credentialDbIdsByHostname_A, (function (hostname, dbId) {
                  var arg = Belt_Option.map(Belt_MapString.get(credentialDbIdsByHostname_B, hostname), (function (dbId$p) {
                          return Caml_obj.caml_equal(dbId, dbId$p);
                        }));
                  var param = false;
                  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }));
  } else {
    return false;
  }
}

var schemaVersion = "0.0.1";

var PasswordCredential;

var OAuthCredential;

exports.schemaVersion = schemaVersion;
exports.PasswordCredential = PasswordCredential;
exports.OAuthCredential = OAuthCredential;
exports.GenericWithoutIdOrSecureData = GenericWithoutIdOrSecureData;
exports.GenericWithoutIdWithPassword = GenericWithoutIdWithPassword;
exports.WithoutIdOrSecureDataAndWithNestedProviderCredentialRef = WithoutIdOrSecureDataAndWithNestedProviderCredentialRef;
exports.WithoutIdWithPasswordAndWithNestedProviderCredentialRef = WithoutIdWithPasswordAndWithNestedProviderCredentialRef;
exports.WithoutIdWithPasswordAndHydratedOAuthProviderCredential = WithoutIdWithPasswordAndHydratedOAuthProviderCredential;
exports.Generic = Generic;
exports.DbId = DbId;
exports.t_encode = t_encode$6;
exports.t_decode = t_decode$6;
exports.stringify = stringify$4;
exports.dbIdGet = dbIdGet;
exports.hostnameGet = hostnameGet$3;
exports.isPasswordCredential = isPasswordCredential;
exports.doesMatchUrl = doesMatchUrl;
exports.WithExistingCredentialOrCreatePasswordCredential = WithExistingCredentialOrCreatePasswordCredential;
exports.WithoutIdOrSecureDataWithNestedNewOrExistingPasswordCredentialForOAuth = WithoutIdOrSecureDataWithNestedNewOrExistingPasswordCredentialForOAuth;
exports.WithoutIdWithPasswordWithNestedNewOrExistingPasswordCredentialForOAuth = WithoutIdWithPasswordWithNestedNewOrExistingPasswordCredentialForOAuth;
exports.DbRecord = DbRecord;
exports.WithReEntryStatusAndOAuthProviderCredential = WithReEntryStatusAndOAuthProviderCredential;
exports.WithOAuthProviderCredential = WithOAuthProviderCredential;
exports.CredentialRef = CredentialRef;
exports.doesMatchCredentialRef = doesMatchCredentialRef;
exports.toWithoutIdOrSecureDataAndWithNestedProviderCredentialRef = toWithoutIdOrSecureDataAndWithNestedProviderCredentialRef;
exports.makeFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef = makeFromWithoutIdOrSecureDataAndWithNestedProviderCredentialRef;
exports.buildDefaultCredentialDbIdsByHostname = buildDefaultCredentialDbIdsByHostname;
exports.areCredentialDbIdsByHostnameIdentical = areCredentialDbIdsByHostnameIdentical;
/* include Not a pure module */
